import React, {Component} from 'react';
import co from 'co';
import {observer} from 'mobx-react';
import {BASE_URL, META_SCREENS, MESSAGE} from 'js/constants';
import {AppStore} from 'js/stores'; // singleton stores
import _RegistrationStore from 'js/stores/registration';
import Modal from 'js/components/modal';
import {BasicButton} from 'js/components/button';
import Mark from './mark';
import Form from './form';
import styles from 'css/screens/registration.css';

@observer
/**
 * Registration screen
 */
export default class Registration extends Component {
  /**
   * constructor
   */
  constructor() {
    super();

    this.RegistrationStore = new _RegistrationStore();
    this.close = this.close.bind(this);
    this.sendMail = this.sendMail.bind(this);
  }

  /**
   * did mount
   */
  componentDidMount() {
    AppStore.pageView(META_SCREENS.registration);
  }

  /**
   * will unmount
   */
  componentWillUnmount() {
    AppStore.pageLoading();
  }

  /**
   * send mail
   */
  sendMail() {
    if (!this.RegistrationStore.check()) {
      this.RegistrationStore.changeCheckState(true);
    } else {
      // ローディング表示
      AppStore.actionLoading(false);

      // メール送信
      co(this.RegistrationStore.sendMailGenerator())
        .then((result) => {
          AppStore.actionLoading(true);
          AppStore.updateStep('regist', true);

          this.props.history.push(`${BASE_URL}/phaseresult`);
        })
        .catch((onerror) => {
          AppStore.actionLoading(true);
        });
    }
  }

  /**
   * close
   */
  close() {
    this.RegistrationStore.clearState();
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <section>
        <div className={`${styles.block} ${styles.top}`}>
          <h1 className={styles.title}>市場創造フェーズ　無料診断結果</h1>
          <div className={styles.note}>
            <span className={styles.line}>
              御社の市場創造フェーズを診断するには以下の登録フォームの記入が必要になります。
            </span>
            <Mark />
            <p className={styles.lead}>
              回答結果にもとづき、御社が市場創造フェーズのどこに位置するかを診断します。<br />
              <br />
              1. 立ち上げフェーズ&nbsp;&nbsp;
              2. 認知フェーズ&nbsp;&nbsp;
              3. コト訴求フェーズ&nbsp;&nbsp;
              4. 習慣化フェーズ<br />
              <br />
              <br />
              また、世に広める新習慣や新カテゴリのキーワード（市場創造記号）7つの要素もご説明します。
            </p>
          </div>
        </div>
        <Form RegistrationStore={this.RegistrationStore} />
        <div className={`${styles.block} ${styles.button}`}>
          <BasicButton onClick={this.sendMail}>
            登録情報を送信して結果を見る
          </BasicButton>
        </div>
        {this.RegistrationStore.state.check && (
          <Modal close={this.close}>{MESSAGE.registration.check}</Modal>
        )}
        {this.RegistrationStore.state.error && (
          <Modal close={this.close}>{MESSAGE.registration.error}</Modal>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/registration/index.js